import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { Subject, debounceTime, takeUntil } from 'rxjs';
import { GetTaxRates$Params } from 'src/api/generated/fn/tax-rate-v-2/get-tax-rates';
import { RemoveTaxRate$Params } from 'src/api/generated/fn/tax-rate-v-2/remove-tax-rate';
import { TaxRateV2Dto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/TaxRatesV2/tax-rate-v-2-dto';
import { TaxRateV2Service } from 'src/api/generated/services';
import { AuthenticationService } from 'src/app/share-modul/services/authentication/authentication.service';
import { AddOrEditTaxRateComponentV2 } from './add-or-edit-tax-rate/add-or-edit-tax-rate.component';
import { CurrentVenueHelperService } from 'src/app/share-modul/services/current-venue-helper/current-venue.helper.service';

@Component({
  selector: 'app-tax-rate',
  templateUrl: './tax-rate.component.html',
  styleUrls: ['./tax-rate.component.scss']
})
export class TaxRateComponent implements OnInit {

  public unsubscribe: Subject<void> = new Subject<void>();
  public taxRates: Array<TaxRateV2Dto>;
  public searchTaxRate: string = "";
  public companyId: string;
  searchDebouncer = new Subject<void>();
  RELOAD_DEBOUNCE_TIME = 500;
  loading: boolean =  false;

  constructor(
    private route: ActivatedRoute,
    public currentVenueHelper: CurrentVenueHelperService,
    private dialogService: DialogService,
    private confirmationService: ConfirmationService,
    private translate: TranslateService,
    private taxRateService: TaxRateV2Service,
    private authenticationService: AuthenticationService
  ) {
    this.companyId = this.authenticationService.getCompanyId()
   }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params['venue-id'] != null) {
        this.currentVenueHelper.updateCurrentVenueIdDropdown(params['venue-id']);
      }
    }); 
    this.getTaxRates();
    this.searchDebouncer.pipe(
      debounceTime(this.RELOAD_DEBOUNCE_TIME)
    ).subscribe(_ => this.getTaxRates());
  }
  
  getTaxRates() {
    this.loading = true;
    var params: GetTaxRates$Params = {} as GetTaxRates$Params;
    params.companyId = this.companyId;
    params.isRemoved = false;
    params.searchTerm = this.searchTaxRate;
    this.taxRateService.getTaxRates(params)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.taxRates = response.taxRates ? response.taxRates : [];
          this.loading = false;
        },
        error: errorResponse => {
        }
      });
  }

  addTaxRate() {
    const ref = this.dialogService.open(AddOrEditTaxRateComponentV2, {
      width: '372px',
      showHeader: false,
      closeOnEscape: false,
      data: {
        companyId : this.companyId
      }
    });
    ref.onClose.subscribe((item: any) => {
      this.getTaxRates();
    });
  }
  editTaxRate(taxRate: TaxRateV2Dto) {
    const ref = this.dialogService.open(AddOrEditTaxRateComponentV2, {
      width: '372px',
      showHeader: false,
      closeOnEscape: false,
      data: {
        item: taxRate,
        companyId : this.companyId
      }
    });
    ref.onClose.subscribe((item: any) => {
      this.getTaxRates();
    });
  }
  deleteTaxRate(taxRate: TaxRateV2Dto) {
    this.confirmationService.confirm({
      header: this.translate.instant('TAX_RATE.DELETE_TAX_RATE_TITLE') + "?",
      message: this.translate.instant('TAX_RATE.DELETE_TAX_RATE_TEXT') + taxRate.name + " ?",
      acceptLabel: this.translate.instant('YES'),
      rejectLabel: this.translate.instant('NO'),
      defaultFocus: "reject",
      closeOnEscape: false,
      acceptButtonStyleClass: 'soc-confirmation-dialog dialog-btn destructive-btn',
      rejectButtonStyleClass: 'soc-confirmation-dialog dialog-btn reject-btn',
      accept: () => {
        var params: RemoveTaxRate$Params = {} as RemoveTaxRate$Params;
        if (taxRate.id) {
          params.taxRateId = taxRate.id;
        }
        this.taxRateService.removeTaxRate(params)
          .pipe(takeUntil(this.unsubscribe))
          .subscribe({
            next: (response) => {
              this.getTaxRates()
            },
            error: errorResponse => {
            }
          });
      }
    });
  }
  searchTermChange(): void {
    this.loading = true;
    this.searchDebouncer.next();
  }
}

